var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0C31.0465 0 40 8.95353 40 20C40 31.0465 31.0465 40 20 40C8.95353 40 0 31.0465 0 20C0 8.95353 8.95353 0 20 0Z",
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1642_14708)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9989 25.2647C11.1599 25.1107 11.3811 25.0208 11.6158 25.0208H32.8982C33.2871 25.0208 33.4815 25.47 33.2066 25.7331L29.0025 29.7562C28.8415 29.9102 28.6203 30 28.3856 30H7.10321C6.7143 30 6.51985 29.5508 6.79477 29.2878L10.9989 25.2647Z",
    fill: "url(#paint0_linear_1642_14708)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.998 10.2438C11.1656 10.0898 11.3869 10 11.6148 10H32.8972C33.2861 10 33.4806 10.4491 33.2057 10.7122L29.0015 14.7353C28.8406 14.8893 28.6193 14.9791 28.3846 14.9791H7.10223C6.71333 14.9791 6.51888 14.53 6.79379 14.2669L10.998 10.2438Z",
    fill: "url(#paint1_linear_1642_14708)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0025 17.7061C28.8415 17.5521 28.6203 17.4623 28.3856 17.4623H7.10321C6.7143 17.4623 6.51985 17.9115 6.79477 18.1745L10.9989 22.1976C11.1599 22.3516 11.3811 22.4415 11.6158 22.4415H32.8982C33.2871 22.4415 33.4815 21.9923 33.2066 21.7292L29.0025 17.7061Z",
    fill: "url(#paint2_linear_1642_14708)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1642_14708",
    x1: 30.8651,
    y1: 7.5967,
    x2: 17.1295,
    y2: 35.0901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1642_14708",
    x1: 24.4238,
    y1: 4.37912,
    x2: 10.6881,
    y2: 31.8725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1642_14708",
    x1: 27.6244,
    y1: 5.97768,
    x2: 13.8888,
    y2: 33.4711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1642_14708"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.6667,
    height: 20,
    fill: "white",
    transform: "translate(6.66699 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolana);
export default __webpack_public_path__ + "static/media/Solana.598df85159c3c0bec9ddbf5d9d9a8111.svg";
export { ForwardRef as ReactComponent };